module.exports = __webpack_public_path__ + "img/win_item10.a34042c0.png";